import { StevensTopbar } from '@/components/landing/StevensTopbar';
import { StevensFooter } from '@/components/landing/StevensFooter';
import { CrisisDisclosure } from '@/components/legal/CrisisDisclosure';
import { DocumentRenderer } from '@/components/legal/DocumentRenderer';
import '../landing-v2.css';

export function SafetyPage() {
  return (
    <div className="landing-page">
      <StevensTopbar />
      <main className="wrap legal-shell">
        <CrisisDisclosure variant="full" />
        <DocumentRenderer doc="crisis" />
      </main>
      <StevensFooter />
    </div>
  );
}
